import youtube from './youtube'
//video
//кнопка play
[].forEach.call(document.querySelectorAll('.media-video__play'), function videPlay(el) {
    el.addEventListener('click', function videPlayEl(event) {
        event.currentTarget.closest('.media-video').querySelector('video').play();
        event.currentTarget.closest('.media-video').classList.add('play');
    })
});


addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.media-rutube:not(.media-fancy)').forEach(item => {
        const wrap = item.querySelector('.media-rutube__iframe-wrap')
        const {videoId} = wrap.dataset;
        wrap.innerHTML += `<iframe  width="720" height="405" src="//rutube.ru/play/embed/${videoId}/?getPlayOptions=duration" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`
        const frame = wrap.querySelector('iframe')

        function play() {
            if(item.closest('.video-youtub-outWraper')) {
                item.closest('.video-youtub-outWraper').classList.add('play')
            }
            item.classList.add('play');
            frame?.contentWindow.postMessage(JSON.stringify(
                {
                    type: 'player:play',
                    data: {}
                }
            ), '*');
            frame?.contentWindow.postMessage(JSON.stringify(
                {
                    type: 'player:unMute',
                    data: {}
                }
            ), '*');

        }
    
        function stop() {
            if(item.closest('.video-youtub-outWraper')) {
                item.closest('.video-youtub-outWraper').classList.remove('play')
            }
            item.classList.remove('play');
            frame?.contentWindow.postMessage(JSON.stringify(
                {
                    type: 'player:stop',
                    data: {}
                }
            ), '*');
        }
    
        let playBtn = item.querySelector('.media-rutube__play');
        if(item.classList.contains('media-outWraper')) {
            playBtn = item.closest('.video-youtub-outWraper').querySelector('.video-youtub-outWraper__play');

            item.closest('.video-youtub-outWraper').querySelector('.video-youtub-outWraper-close').addEventListener('click', (e) => {
                stop();
            });
        }
        playBtn.addEventListener('click', (e) => {
            item.classList.contains('play') ? stop() : play();
        });
    })


    addEventListener('message', e => {
        try {
            const message = JSON.parse(e.data);

            switch (message.type) {
                case 'player:playOptionsLoaded': {
                    const frame = [...document.querySelectorAll('iframe')].find(el => el.contentWindow == e.source);
                    if (!frame && !frame.closest('.media-rutube:not(.media-fancy)')) break;
                    const frameWrap = frame.closest('.media-rutube')
                    const duration = Math.ceil(message.data.duration / 1000);
                    
                    
                    let typeTime = 'video'
                    if(frameWrap.classList.contains('media-baristaschool')) {
                        typeTime = 'video-long'
                    }
                    let currentTime = calculateCurrentValue(duration, typeTime);
                    let sizeItems;
                    if(frameWrap.closest('.media')) {
                        sizeItems = frameWrap.closest('.media').querySelectorAll('.media-size');
                    }
                    else {
                        sizeItems = frameWrap.querySelectorAll('.media-size');
                    }

                    if(sizeItems.length && !Number.isNaN(duration)) {
                        sizeItems.forEach(sizeItem => {
                            sizeItem.textContent = currentTime;
                        });
                    }
                }
        
            };
        } catch (error) {
            
        }
    })

    document.querySelectorAll('.media-vk:not(.media-fancy)').forEach(item => {
        const wrap = item.querySelector('.media-vk__iframe-wrap')
        const {videoId, ownerId} = wrap.dataset;
        wrap.innerHTML += `<iframe class="w-full h-full" src="//vk.com/video_ext.php?oid=-${ownerId}&id=${videoId}&hd=2&js_api=1" width="853" height="480" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen ></iframe>`
        const frame = wrap.querySelector('iframe')
        const player = VK.VideoPlayer(frame);
        console.log(player.getState())
        player.on('inited', (state) => {            
            let typeTime = 'video'
            if(item.classList.contains('media-baristaschool')) {
                typeTime = 'video-long'
            }
            let currentTime = calculateCurrentValue(state.duration, typeTime);
            let sizeItems;
            if(item.closest('.media')) {
                sizeItems = item.closest('.media').querySelectorAll('.media-size');
            }
            else {
                sizeItems = item.querySelectorAll('.media-size');
            }

            if(sizeItems.length && !Number.isNaN(state.duration)) {
                sizeItems.forEach(sizeItem => {
                    sizeItem.textContent = currentTime;
                });
            }
        })

        function play() {
            if(item.closest('.video-youtub-outWraper')) {
                item.closest('.video-youtub-outWraper').classList.add('play')
            }
            item.classList.add('play');
        }
    
        function stop() {
            if(item.closest('.video-youtub-outWraper')) {
                item.closest('.video-youtub-outWraper').classList.remove('play')
            }
            item.classList.remove('play');
        }
    
        let playBtn = item.querySelector('.media-vk__play');
        if(item.classList.contains('media-outWraper')) {
            playBtn = item.closest('.video-youtub-outWraper').querySelector('.video-youtub-outWraper__play');

            item.closest('.video-youtub-outWraper').querySelector('.video-youtub-outWraper-close').addEventListener('click', (e) => {
                stop();
            });
        }
        playBtn.addEventListener('click', (e) => {
            item.classList.contains('play') ? stop() : play();
        });
    })

    

})

youtube.ready(() => {
    const $$players = document.querySelectorAll('.media-youtube:not(.media-fancy)');
    $$players.forEach(item => {
        // eslint-disable-next-line
        const player = new YT.Player(item.querySelector('iframe'), {
            events: {
                onReady,
            }
        });

        function play() {
            if(item.closest('.video-youtub-outWraper')) {
                item.closest('.video-youtub-outWraper').classList.add('play')
            }
            item.classList.add('play');
            player.playVideo();
        }

        function stop() {
            if(item.closest('.video-youtub-outWraper')) {
                item.closest('.video-youtub-outWraper').classList.remove('play')
            }
            item.classList.remove('play');
            player.stopVideo();
        }

        function onSlideChange(swiper) {
            swiper.on('slideChange', stop)
        }

        function onReady() {
            let playBtn = item.querySelector('.media-youtube__play');
            if(item.classList.contains('media-outWraper')) {
                playBtn = item.closest('.video-youtub-outWraper').querySelector('.video-youtub-outWraper__play');

                item.closest('.video-youtub-outWraper').querySelector('.video-youtub-outWraper-close').addEventListener('click', (e) => {
                    stop();
                });
            }

            playBtn.addEventListener('click', (e) => {
                item.classList.contains('play') ? stop() : play();
            });
            let typeTime = 'video'
            if(item.classList.contains('media-baristaschool')) {
                typeTime = 'video-long'
            }
            let currentTime = calculateCurrentValue(player.getDuration(), typeTime);

            let sizeItems;
            if(item.closest('.media')) {
                sizeItems = item.closest('.media').querySelectorAll('.media-size');
            }
            else {
                sizeItems = item.querySelectorAll('.media-size');
            }
            if(sizeItems) {
                sizeItems.forEach(sizeItem => {
                    sizeItem.textContent = currentTime;
                });
            }

        }
    });
});

// let newScript = document.createElement("script");
// newScript.src = "https://www.youtube.com/iframe_api";
// document.head.append(newScript);

//pause
document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll('.media-video video'), function video(el) {


        el.onloadedmetadata = function() {
            let typeTime = 'video'
            if(el.closest('.media-video').classList.contains('media-baristaschool')) {
                typeTime = 'video-long'
            }
            let currentTime = calculateCurrentValue(el.duration, typeTime);

            let sizeItems;
            if(el.closest('.media')) {
                sizeItems = el.closest('.media').querySelectorAll('.media-size');
            }
            else {
                sizeItems = el.closest(".media-video").querySelectorAll('.media-size');
            }
            if(sizeItems) {
                sizeItems.forEach(sizeItem => {
                    sizeItem.textContent = currentTime;
                });
            }
        };

        el.addEventListener('click', function videoEl(event) {
            event.currentTarget.pause();
            if(event.currentTarget.closest('.media-video').hasAttribute('play-start')) {
                el.currentTime = 0;
            }
            event.currentTarget.closest('.media-video').classList.remove('play');
        })
    });
});

let currentPlaying = null;
//mp3
//кнопка play
[].forEach.call(document.querySelectorAll('.media-audio__play'), function audioPlay(el) {
    el.addEventListener('click', function audioPlayEl(event) {
        if (event.target.closest('.media-audio').classList.contains('play')) {
            currentPlaying = null;
            event.currentTarget.closest('.media-audio').querySelector('audio').pause();
            event.currentTarget.closest('.media-audio').classList.remove('play');
        }
        else {
            const audio = event.currentTarget.closest('.media-audio').querySelector('audio');
            if (currentPlaying) {
                currentPlaying.pause();
                currentPlaying.closest('.media-audio').classList.remove('play');
            }
            currentPlaying = audio;
            audio.play();
            event.currentTarget.closest('.media-audio').classList.add('play');
        }
    })
});
//track
function calculateCurrentValue(currentTime, type = null) {
    const currentMinute = parseInt(currentTime / 60) % 60;
    const currentSecondsLong = currentTime % 60;
    const currentSeconds = currentSecondsLong.toFixed();

    let currentTimeFormatted = `${currentMinute < 10 ? `0${currentMinute}` : currentMinute}:${
    currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds}`;

    if(type == "video") {
        currentTimeFormatted = ""
        if(parseInt(currentMinute) > 0) {
            currentTimeFormatted = currentMinute + " мин"
        }
        if(parseInt(currentSeconds) > 0) {
            currentTimeFormatted = currentTimeFormatted + " " + currentSeconds + " сек"
        }
    }
    else if( type == 'video-long') {
        currentTimeFormatted = ""
        if(parseInt(currentMinute) > 0) {
            currentTimeFormatted = currentMinute + ":"
        }
        if(parseInt(currentSeconds) > 0) {
            currentTimeFormatted = currentTimeFormatted + `${currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds}`
        }

        if(parseInt(currentMinute) > 0) {
            currentTimeFormatted = currentTimeFormatted + " мин"
        }
        else if(parseInt(currentSeconds) > 0) {
            currentTimeFormatted = currentTimeFormatted + " сек"
        }
    }
    return currentTimeFormatted;
}
document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll('.media-audio audio'), function audio(el) {
        let attrTime = el.dataset.duration;
        if (attrTime) {
            el.closest(".media-audio").querySelector('.media-audio__time').textContent = calculateCurrentValue(attrTime);
        } else {
            el.onloadedmetadata = function() {
                let currentTime = calculateCurrentValue(el.duration);
                el.closest(".media-audio").querySelector('.media-audio__time').textContent = currentTime;
            };
        }
        el.addEventListener('timeupdate', function audioEl(event) {
            let percent = el.currentTime * 100 / el.duration;

            const currentTime = calculateCurrentValue(el.duration-el.currentTime);
            event.currentTarget.closest('.media-audio').querySelector('.media-audio__time').textContent = currentTime;

            event.currentTarget.closest('.media-audio').querySelector('.media-audio__track-active').style.width=percent+"%";
            if (el.ended) {
            //end
            event.currentTarget.closest('.media-audio').classList.remove('play');
            }
        })
    });
});

export { calculateCurrentValue };